import Text from "antd/lib/typography/Text";

export default function Report() {
  return <Text>We're still building this</Text>;
}
